module.exports = __webpack_public_path__ + "static/img/agent-ai-menu.13eec0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-ai/agent-ai-menu.png
// module id = p4Y+
// module chunks = 20